import { tv } from "@fanka/tailwind-variants";
import clsx from "clsx";

export const SEARCH_FLOAT_OPTIONS_ROW_CLASS_NAME = tv({
  base: clsx(
    "px-[20px] py-[10px] cursor-pointer border-b border-grayScale-200",
    // hover
    "hover:bg-grayScale-200",
  ),
  variants: {
    disable: {
      true: "text-base-disabled",
    },
    active: {
      true: "bg-grayScale-300 text-base-0",
    },
  },
});
